import { jsxs as k, jsx as l } from "react/jsx-runtime";
import { clsx as g } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useState as O, useRef as h } from "react";
import { useEscapeKey as y } from "../../utils/use-escape-key.js";
import { useFocusOutside as S } from "../../utils/use-focus-outside.js";
import { RocheUIIcon as E } from "../icon/roche-icon.js";
import a from "./roche-language-switch.dropdown.module.scss.js";
import o from "./roche-language-switch.inline-list.module.scss.js";
import { RocheUILanguageSwitchLayoutType as L } from "./roche-language-switch.types.js";
const z = ({
  alternates: p,
  currentLocale: M,
  currentPage: w,
  translatedLocale: s,
  translatedAriaLabel: R,
  layout: v,
  onClick: _
}) => {
  const [i, c] = O(!1), t = h(null), m = h(null), u = h(null);
  y(() => c(!1), i), S(t, i, () => c(!1), m);
  const x = (r) => {
    c((n) => {
      const e = !n;
      return t.current = e ? r.current : null, e;
    });
  }, f = (r) => {
    c(!0), t.current = r.current;
  }, N = () => {
    c(!1), t.current = null;
  }, C = (r) => /* @__PURE__ */ l("div", { className: o["language-switch-inline"], children: /* @__PURE__ */ l("ul", { className: o["language-switch-inline__list"], children: r.map((n, e) => {
    const d = n.url === w;
    return s[n.locale] && // biome-ignore lint/suspicious/noArrayIndexKey: an id would be better
    /* @__PURE__ */ l("li", { className: o["language-switch-inline__list-item"], children: d ? /* @__PURE__ */ l(
      "span",
      {
        className: g(
          o["language-switch-inline__link"],
          d && o["language-switch-inline__link--selected"]
        ),
        "aria-current": "page",
        "aria-disabled": !0,
        children: s[n.locale]
      }
    ) : /* @__PURE__ */ l(
      "a",
      {
        className: o["language-switch-inline__link"],
        href: n.url,
        "aria-disabled": !1,
        onClick: () => _(n.locale, n.url),
        children: s[n.locale]
      }
    ) }, e);
  }) }) }), I = (r, n) => /* @__PURE__ */ k(
    "div",
    {
      className: g(
        a["language-switch-dropdown"],
        i && a["language-switch-dropdown__open"]
      ),
      children: [
        /* @__PURE__ */ k(
          "button",
          {
            ref: m,
            className: a["language-switch-dropdown__button"],
            id: "language-switch-button",
            "aria-expanded": i,
            "aria-controls": "language-switch-list",
            "aria-label": R,
            onClick: () => x(u),
            onMouseEnter: () => f(u),
            onMouseLeave: N,
            type: "button",
            children: [
              n.toUpperCase(),
              /* @__PURE__ */ l("span", { className: a["language-switch-dropdown__chevron-icon"], children: /* @__PURE__ */ l(E, { icon: "chevron-down", width: "18px" }) })
            ]
          }
        ),
        /* @__PURE__ */ l(
          "ul",
          {
            ref: u,
            className: a["language-switch-dropdown__list"],
            id: "language-switch-list",
            "aria-hidden": !i,
            onMouseEnter: () => f(u),
            onMouseLeave: N,
            inert: i ? null : "",
            children: r.map((e, d) => {
              const b = e.url === w;
              return s[e.locale] && // biome-ignore lint/suspicious/noArrayIndexKey: an id would be better
              /* @__PURE__ */ l("li", { className: a["language-switch-dropdown__list-item"], children: b ? /* @__PURE__ */ l(
                "span",
                {
                  className: g(
                    a["language-switch-dropdown__link"],
                    b && a["language-switch-dropdown__link--selected"]
                  ),
                  "aria-current": "page",
                  "aria-disabled": !0,
                  children: s[e.locale]
                }
              ) : /* @__PURE__ */ l(
                "a",
                {
                  href: e.url,
                  onClick: () => _(e.locale, e.url),
                  className: a["language-switch-dropdown__link"],
                  "aria-disabled": !1,
                  children: s[e.locale]
                }
              ) }, d);
            })
          }
        )
      ]
    }
  );
  return v === L.DROPDOWN ? I(p, M) : C(p);
};
export {
  z as RocheUILanguageSwitch
};
